import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { isEmpty } from 'lodash';
import { Observable, Subject } from 'rxjs';
import { map, startWith, takeUntil } from 'rxjs/operators';
import { FilterListFieldEntry } from '../../model/filter-list-field-entry';
import { FilterListFieldType } from '../../model/filter-list-field-type';
import { FilterDataProvider } from '../../service/filter-data-provider';

@Component({
  selector: 'app-filter-builder-list-field',
  templateUrl: './filter-builder-list-field.component.html',
  styleUrls: ['./filter-builder-list-field.component.scss']
})
export class FilterBuilderListFieldComponent implements OnInit, OnDestroy {

  @Input() fieldControl: AbstractControl;
  @Input() fieldType: FilterListFieldType;

  private readonly destroy$ = new Subject<void>();

  availableValues: FilterListFieldEntry[] = [];
  filteredValues$: Observable<FilterListFieldEntry[]>;
  loading$: Observable<boolean>;

  constructor(private filterDataProvider: FilterDataProvider) { }

  ngOnInit(): void {
    if (!this.fieldType) {
      console.warn('Empty field type');
      return;
    }
    this.fieldControl.disable();
    this.loading$ = this.filterDataProvider.getLoadingState(this.fieldType)
      .pipe(
        takeUntil(this.destroy$),
      );
    this.filterDataProvider
      .getFieldAvailableValues(this.fieldType)
      .pipe(
        takeUntil(this.destroy$),
      )
      .subscribe(v => {
        this.availableValues = v;
        this.setupFilter();
        this.fieldControl.enable();
        this.refreshDisplayedValue();
      });
  }

  // Wymuś ponowne wywołanie displayFn. Potrzeba przy patchu z filtrami usera lub historii wyszukiwań.
  refreshDisplayedValue(): void {
    const currentValue = this.fieldControl.value;
    if (currentValue) {
      this.fieldControl.setValue(currentValue, { emitEvent: false });
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  displayFn = (id: string | null): string => {
    if (!id) return '';
    return this.availableValues.find(v => v.id === id)?.displayValue ?? id;
  };

  resetState(): void {
    this.fieldControl.reset();
  }

  private setupFilter(): void {
    this.filteredValues$ = this.fieldControl.valueChanges.pipe(
      takeUntil(this.destroy$),
      startWith(this.fieldControl.value),
      map(value => !isEmpty(value)
        ? this.availableValues.filter(v => v.displayValue.toLowerCase().includes(value.toLowerCase()))
        : this.availableValues.slice()
      )
    );
  }

}
